import { Card, CardTitle, DataTable, EmptyState, type DataTableColumn } from '@wundo/ui';

export interface CostTableCardProps<Row> {
  title: string;
  /** The table's accessible name. */
  label: string;
  columns: DataTableColumn<Row>[];
  rows: Row[];
  rowKey: (row: Row) => string;
}

/** One breakdown of the costs, as a titled table. */
export function CostTableCard<Row>({
  title,
  label,
  columns,
  rows,
  rowKey,
}: CostTableCardProps<Row>) {
  return (
    <Card as='section' className='flex flex-col gap-3.5'>
      <CardTitle>{title}</CardTitle>
      <DataTable<Row>
        label={label}
        columns={columns}
        rows={rows}
        rowKey={rowKey}
        emptyState={<EmptyState title='No data' headingLevel='h3' />}
      />
    </Card>
  );
}
